<template>
  <v-container>
    <div>
      <v-row justify="start">
        <v-col cols="12" sm="3">
          <vc-date-picker mode="range" v-model="dateRange" :popover="{label: 'Hover', visibility: 'hover'}">
          </vc-date-picker>
        </v-col>

        <v-col cols="12" sm="2" justify="end">
          <v-btn color="primary" dark @click="getData">{{ $t('common.search') }}</v-btn>
        </v-col>

        <v-col cols="12" sm="7">
          <div class="d-flex flex-row-reverse">
            <v-btn color="primary" dark @click="getData">{{ $t('common.refresh') }}</v-btn>
          </div>
        </v-col>
      </v-row>
    </div>

    <v-data-table :headers="headers" :items="desserts" :search="search" sort-by="date" class="elevation-1"
                  hide-default-footer :page.sync="page" :loading="loading" :items-per-page="itemsPerPage"
                  @page-count="pageCount = $event" :item-class="itemRowBackground">
      <template v-slot:top>
        <v-toolbar flat color="white" class="pt-5">
          <v-row justify="start">
            <v-col cols="12" sm="2">
              <span>Tổng số: <span class="summaryFont"> {{ totalManufactureRequest }} </span> </span>
            </v-col>
            <v-spacer></v-spacer>
            <v-col cols="12" sm="1">
              <v-autocomplete v-model="itemsPerPage" :items="numberPage" outlined :dense="true"></v-autocomplete>
            </v-col>

            <v-col cols="12" sm="2">
              <v-autocomplete v-model="selectReadStatus" :items="readStatus" item-text="title" outlined :dense="true" return-object></v-autocomplete>
            </v-col>

            <v-col cols="12" sm="2" v-if="!isAdmin && userCategory > 1">
              <v-autocomplete v-model="selectJobFilter" :items="jobFilters" item-text="title" dense return-object
                              outlined></v-autocomplete>
            </v-col>
            <v-col cols="12" sm="5">
              <v-text-field v-model="search" append-icon="search" v-bind:label="$t('common.search')" single-line
                            hide-details outlined :dense="true"></v-text-field>
            </v-col>
          </v-row>
        </v-toolbar>
      </template>

      <template v-slot:[`item.sale`]="{ item }">
        <div class="contentAddress">
          <v-tooltip slot="append-outer" bottom max-width="300px" color="primary">
            <template v-slot:activator="{ on }">
              <v-avatar v-on="on" size="30" class="mr-1">
                <img v-if="item.sale.avatar" :src="baseImage + item.sale.avatar"/>
                <img v-else src='@/assets/avatar_default.png'/>
              </v-avatar>
            </template>
            <span>
                  {{ item.sale.fullname }}
                </span>
          </v-tooltip>
          <span>
                {{ item.sale.nickname }}
              </span>
        </div>
      </template>

      <template v-slot:[`item.designer`]="{ item }">
        <div class="contentAddress">
          <v-tooltip slot="append-outer" bottom max-width="300px" color="primary">
            <template v-slot:activator="{ on }">
              <v-avatar v-on="on" size="30" class="mr-1">
                <img v-if="item.designer.avatar" :src="baseImage + item.designer.avatar"/>
                <img v-else src='@/assets/avatar_default.png'/>
              </v-avatar>
            </template>
            <span>
                  {{ item.designer.fullname }}
                </span>
          </v-tooltip>
          <span>
                {{ item.designer.nickname }}
              </span>
        </div>
      </template>

      <template v-slot:[`item.createdAt`]="{ item }">
        <span class="text-no-wrap">{{ item.createdAt | formateDate }}</span>
      </template>


      <template v-slot:[`item.upload`]="{ item }">
        <v-btn color="primary" @click="showListFilesUploaded(item)">
          {{ $t('design_manager.upload') }}
        </v-btn>
      </template>

      <template v-slot:[`item.action`]="{ item }">
        <div class="contentTitle">
          <v-tooltip slot="append-outer" bottom max-width="300px" color="primary">
            <template v-slot:activator="{ on }">
              <v-icon v-on="on" small class="mr-2" @click="showDetail(item)">
                info
              </v-icon>
            </template>
            <span>Thông tin chi tiết</span>
          </v-tooltip>

          <v-tooltip slot="append-outer" bottom max-width="300px" color="primary">
            <template v-slot:activator="{ on }">
              <v-icon v-on="on" small class="mr-2" @click="showListFilesUploaded(item)">
                attach_file
              </v-icon>
            </template>
            <span>Đính kèm file</span>
          </v-tooltip>

          <v-tooltip slot="append-outer" bottom max-width="300px" color="primary">
            <template v-slot:activator="{ on }">
              <v-icon v-on="on" small class="mr-2" @click="showGDrive(item)">
                cloud_upload
              </v-icon>
            </template>
            <span>Đính kèm từ Google Drive</span>
          </v-tooltip>
        </div>
      </template>

      <template v-slot:[`item.designRequest.requestTitle`]="{ item }">
        <span class="contentTitle">
          {{ item.designRequest.requestTitle + (item.designRequest.orderUnit ? (' - ' + item.designRequest.orderUnit.name) : '') }}
        </span>
      </template>

      <template v-slot:[`item.customer.fullname`]="{ item }">
        <span class="contentName">
          {{ item.customer.fullname }}
        </span>
      </template>

      <template v-slot:[`item.forward`]="{ item }">
        <v-btn color="primary" @click="validateEffortBeforeApprove(item)" :disabled="checkFileAttach(item)">
          {{ $t('common.approve') }}
        </v-btn>
      </template>

      <template v-slot:[`item.gDrive`]="{ item }">
        <v-btn color="primary" @click="showGDrive(item)">
          Google Drive
        </v-btn>
      </template>

      <template v-slot:no-data>
        <!-- <v-btn color="primary" @click="initialize">Reset</v-btn> -->
      </template>
    </v-data-table>

    <div class="text-center pt-2">
      <v-pagination v-model="page" :length="pageCount"></v-pagination>
    </div>

    <v-dialog v-model="dialog" max-width="60%">
      <v-card>
        <v-card-title>
          <span class="headline">Chọn danh sách file để upload</span>
        </v-card-title>
        <v-card-text>
          <v-container>
            <v-row v-for="(file, index ) in files" :key="file.id">
              <v-col cols="12" sm="6">
                <span> {{ (index + 1) + '.' }} {{ file.name }} </span>
              </v-col>
              <v-col cols="12" sm="2">
                <v-icon @click="deleteFileBeforeUpload(file)"> delete</v-icon>
              </v-col>
            </v-row>

            <v-row>
              <file-upload :multiple="true" v-model="files">
                <v-btn> {{ $t('common.chosen_file') }}</v-btn>
              </file-upload>
            </v-row>
          </v-container>

          <v-divider></v-divider>
          <v-toolbar flat>
            <v-btn color="primary" width="120px" @click="cancelUpload">{{ $t('common.cancel') }}</v-btn>

            <v-spacer></v-spacer>

            <v-btn color="primary" @click="uploadFileData" width="120px" class="mr-5">
              {{ $t('common.ok') }}
            </v-btn>
          </v-toolbar>
        </v-card-text>
      </v-card>
    </v-dialog>

    <v-dialog v-model="dialogFileUploaded" max-width="60%">
      <v-card>
        <v-card-title>
          <span class="headline">Danh sách file đã upload</span>
        </v-card-title>
        <v-card-text>
          <v-container>
            <v-row v-for="(file, index ) in designFilesUploaded" :key="file._id">
              <v-col cols="12" sm="8">
                <span class="text-no-wrap"> {{ (index + 1) + '.' }} {{ file.filename }} </span>
              </v-col>
              <v-col cols="12" sm="2">
                <v-icon @click="deleteFile(file)"> delete</v-icon>
              </v-col>
            </v-row>
          </v-container>

          <v-divider></v-divider>
          <v-toolbar flat>
            <v-btn color="primary" width="120px" @click="closeListFilesUploaded">{{ $t('common.close') }}</v-btn>

            <v-spacer></v-spacer>

            <v-btn color="primary" @click="uploadFiles" width="120px" class="mr-5">
              {{ $t('common.chosen_file') }}
            </v-btn>
          </v-toolbar>
        </v-card-text>
      </v-card>
    </v-dialog>

    <manufacture-request-dialog v-model="dialogDetail" :editedItem="editedItem" :editable="false"
                                @closeDialog="closeDetail"
                                v-if="editedItem">
    </manufacture-request-dialog>

    <google-drive-select v-model="gDriveDialog" :editedItem="editedItem" @closeDialogGDrive="closeGDrive"
                         @cancelUploadGDrive="cancelGDrive"
                         v-if="editedItem">
    </google-drive-select>

    <rate-dialog :dialog="rateDialog" @closeDialog="closeRate" :targetUser="sale"></rate-dialog>

    <v-overlay :value="overlay">
      <v-progress-circular indeterminate size="64"></v-progress-circular>
    </v-overlay>
  </v-container>
</template>

<script>
import i18n from '@/plugins/i18n';
import moment from 'moment';
import ManufactureRequestDialog from "@/components/ManufactureRequestDialog";
import FileUpload from 'vue-upload-component';
import RateDialog from "@/components/RateDialog";
import GoogleDriveSelect from "@/components/GoogleDriveSelect";
import socketClient from '@/plugins/socketClient';

export default {
  data: () => ({
    baseImage: process.env.VUE_APP_BASE_IMAGE,
    baseAttach: process.env.VUE_APP_BASE_ATTACH,

    dateRange: {start: new Date(new Date().setDate(new Date().getDate() - 7)), end: new Date()},
    isAdmin: localStorage.getItem('isAdmin') === 'true' ? true : false,
    userCategory: parseInt(localStorage.getItem('category')),
    userID: localStorage.getItem('user_id'),

    selectJobFilter: {},
    jobFilters: [
      {title: i18n.t('common.owner_job'), value: 0},
      {title: i18n.t('common.staff_job'), value: 1}
    ],

    selectReadStatus: {title: i18n.t('common.all'), value: -1},
    readStatus: [
      {title: i18n.t('common.unread'), value: 0},
      {title: i18n.t('common.read'), value: 1},
      {title: i18n.t('common.all'), value: -1}
    ],

    personalJobs: [],
    staffJobs: [],

    loading: true,
    numberPage: [
      5, 10, 15, 20, 25
    ],

    timeoutProcess: 24,

    page: 1,
    pageCount: 0,
    itemsPerPage: 10,

    selectedManufactureRequest: {},
    search: '',
    dialog: false,
    dialogDetail: false,
    rateDialog: false,
    gDriveDialog: false,
    dialogFileUploaded: false,
    designFilesUploaded: [],

    overlay: false,
    isSearching: false,
    sale: {},

    files: [],
    // uploadedFiles: [],
    totalManufactureRequest: 0,

    headers: [],
    desserts: [],
    editedIndex: -1,
    editedItem: null,
    stringRules: [
      v => !!v || i18n.t('validate.not_empty'),
      v => (v && v.length > 5) || i18n.t('validate.string_invalid')
    ]
  }),

  computed: {},

  components: {
    ManufactureRequestDialog: ManufactureRequestDialog,
    FileUpload: FileUpload,
    RateDialog: RateDialog,
    GoogleDriveSelect: GoogleDriveSelect
  },

  watch: {
    dialog(val) {
      val || this.close()
    },

    selectReadStatus() {
      this.filterData();
    },

    files(val) {
      val.forEach(file => {
        if (file.file.size > 5 * 1024 * 1024) {
          alert("File " + file.file.name + " đã chọn vượt quá 5M");
          val.splice(file, 1);
        }
      });
    },

    selectJobFilter() {
      if (this.selectJobFilter.value === 1) {
        this.headers = [
          {text: '#', align: 'left', sortable: false, value: 'index',},
          {text: i18n.t('design_manager.code_manufacture'), sortable: false, value: 'code'},
          {text: i18n.t('design_manager.code'), sortable: false, value: 'designRequest.code'},
          {text: i18n.t('design_manager.name'), sortable: false, value: 'designRequest.requestTitle'},
          // { text: i18n.t('design_manager.customer'), sortable: false, value: 'customer.fullname'},
          {text: i18n.t('design_manager.date'), value: 'createdAt'},
          {text: i18n.t('design_manager.designer'), sortable: false, value: 'designer'},
          {text: '', sortable: false, value: 'designer.fullname', align: ' d-none'},

          {text: i18n.t('design_manager.sale'), sortable: false, value: 'sale'},
          {text: '', sortable: false, value: 'sale.fullname', align: ' d-none'},
          {text: i18n.t('design_manager.infor'), align: 'center', sortable: false, value: 'action'},

          // { text: i18n.t('design_manager.action'), align: 'center', sortable: false, value: 'upload'},
          // { text: i18n.t('design_manager.action'), align: 'center', sortable: false, value: 'gDrive'},
          {text: '', align: 'center', sortable: false, value: 'forward'}
        ]
      } else {
        this.headers = [
          {text: '#', align: 'left', sortable: false, value: 'index',},
          {text: i18n.t('design_manager.code_manufacture'), sortable: false, value: 'code'},
          {text: i18n.t('design_manager.code'), sortable: false, value: 'designRequest.code'},
          {text: i18n.t('design_manager.name'), sortable: false, value: 'designRequest.requestTitle'},
          // { text: i18n.t('design_manager.customer'), sortable: false, value: 'customer.fullname'},
          {text: i18n.t('design_manager.date'), value: 'createdAt'},
          {text: i18n.t('design_manager.sale'), sortable: false, value: 'sale'},
          {text: '', sortable: false, value: 'sale.fullname', align: ' d-none'},
          {text: i18n.t('design_manager.infor'), align: 'center', sortable: false, value: 'action'},

          // { text: i18n.t('design_manager.action'), align: 'center', sortable: false, value: 'upload'},
          // { text: i18n.t('design_manager.action'), align: 'center', sortable: false, value: 'gDrive'},
          {text: '', align: 'center', sortable: false, value: 'forward'}
        ]
      }

      this.filterData();
    },
  },

  created() {
    if (this.isAdmin) {
      this.headers = [
        {text: '#', align: 'left', sortable: false, value: 'index',},
        {text: i18n.t('design_manager.code_manufacture'), sortable: false, value: 'code'},
        {text: i18n.t('design_manager.code'), sortable: false, value: 'designRequest.code'},
        {text: i18n.t('design_manager.name'), sortable: false, value: 'designRequest.requestTitle'},
        // { text: i18n.t('design_manager.customer'), sortable: false, value: 'customer.fullname'},
        {text: i18n.t('design_manager.date'), value: 'createdAt'},
        {text: i18n.t('design_manager.designer'), sortable: false, value: 'designer'},
        {text: '', sortable: false, value: 'designer.fullname', align: ' d-none'},

        {text: i18n.t('design_manager.sale'), sortable: false, value: 'sale'},
        {text: '', sortable: false, value: 'sale.fullname', align: ' d-none'},
        {text: i18n.t('design_manager.infor'), align: 'center', sortable: false, value: 'action'},

        // { text: i18n.t('design_manager.action'), align: 'center', sortable: false, value: 'upload'},
        // { text: i18n.t('design_manager.action'), align: 'center', sortable: false, value: 'gDrive'},
        {text: '', align: 'center', sortable: false, value: 'forward'}
      ]
    } else {
      this.selectJobFilter = this.jobFilters[0];
    }
    this.getSettingInfor();
    this.getData();
    this.isSearching = true;

    const self = this;
    socketClient.getIO().on('CREATE_MANUFACTURE_REQUEST', () => {
      console.log('ACCOUNTANT_APPROVE_MANUFACTURE_REQUEST');
      self.getData();
    });

    socketClient.getIO().on('ACCOUNTANT_APPROVE_MANUFACTURE_REQUEST', () => {
      console.log('ACCOUNTANT_APPROVE_MANUFACTURE_REQUEST');
      self.getData();
    });

  },

  methods: {
    initialize() {
    },

    closeRate(value) {
      this.rateDialog = value;
    },

    closeDetail(value) {
      this.dialogDetail = value
      this.editedItem = null;
    },

    showDetail(item) {
      console.log("showDetail");
      this.editedIndex = this.desserts.indexOf(item)
      this.editedItem = Object.assign({}, item)
      this.dialogDetail = true;
    },

    showListFilesUploaded(item) {
      this.editedIndex = this.desserts.indexOf(item);
      this.selectedManufactureRequest = item;
      this.designFilesUploaded = [].concat(item.files);
      this.dialogFileUploaded = true;
    },

    closeListFilesUploaded() {
      this.dialogFileUploaded = false;
    },

    showGDrive(item) {
      this.editedIndex = this.desserts.indexOf(item)
      this.editedItem = Object.assign({}, item)
      this.gDriveDialog = true;
    },

    closeGDrive(value) {
      this.gDriveDialog = value;
      this.updateManufactureRequestInforGDrive();
    },

    cancelGDrive(value) {
      this.gDriveDialog = value;
      this.editedItem = null;
    },

    uploadFiles() {
      this.files = [];
      this.dialog = true;
    },

    async deleteFile(file) {
      const agree = confirm(i18n.t('common.confirm_delete'));
      if (agree) {
        this.designFilesUploaded.splice(this.designFilesUploaded.indexOf(file), 1);
        this.selectedManufactureRequest.files = this.designFilesUploaded;
        await this.updateManufactureRequestInfor();
      }
    },

    checkFileAttach(manufactureRequest) {
      if (manufactureRequest.files.length > 0 || manufactureRequest.gDrive.length > 0) {
        return false;
      }

      return true;
    },

    cancelUpload() {
      this.dialog = false;
    },

    close() {
      this.dialog = false;
    },

    async getData() {
      // const userID = localStorage.getItem('user_id');
      const self = this;
      self.overlay = this.isSearching;
      try {
        // const response = await this.$http.get('/designRequest');
        const from = moment(String(this.dateRange.start)).format("DD/MM/YYYY");
        const to = moment(String(this.dateRange.end)).format("DD/MM/YYYY");

        // const response = await this.$http.get('/manufactureRequest/designer/' + userID + '/status/1?' + "from=" + from + "&to=" + to);
        const response = await this.$http.get(process.env.VUE_APP_GET_MANUFACTURE_REQUEST_CONTEXT_API + "?designerStatus=1&from=" + from + "&to=" + to);
        self.overlay = false;
        if (response.data && response.data.success) {
          self.personalJobs = [];
          self.staffJobs = [];

          const contextArr = response.data.data;
          contextArr.forEach((item, index) => item.index = index + 1);
          this.desserts = [].concat(contextArr);

          this.desserts.forEach(item => {
            const designer = item.designer;
            if (designer && designer._id == self.userID) {
              self.personalJobs.push(item);
            } else {
              self.staffJobs.push(item);
            }
          })
          self.filterData();

          this.totalManufactureRequest = this.desserts.length;
          self.loading = false;
        }
      } catch (e) {
        console.log(e.stack);
      }
    },

    filterData() {
      if (this.selectJobFilter && this.selectJobFilter.value === 0) {
        this.desserts = [].concat(this.personalJobs);
      } else {
        this.desserts = [].concat(this.staffJobs);
      }

      if (this.selectReadStatus.value !== -1) {
        this.desserts = [].concat(this.desserts.filter(item => item.designerReadStatus == this.selectReadStatus.value));
      }

      this.totalManufactureRequest = this.desserts.length;
    },

    deleteFileBeforeUpload(file) {
      if (Array.isArray(this.files) && this.files.length > 0) {
        this.files.splice(this.files.indexOf(file), 1);
      }
    },

    async uploadFileData() {
      this.overlay = true;
      const self = this;
      if (Array.isArray(self.files) && self.files.length > 0) {
        let formData = new FormData();
        console.log(self.files);

        self.files.forEach(file => {
          formData.append('files', file.file);
        });

        console.log(formData);

        const response = await self.$httpUpload.post("/uploadFile/", formData);

        if (Array.isArray(response.data) && response.data.length > 0) {
          // self.uploadedFiles = this.uploadedFiles.concat(response.data);
          self.designFilesUploaded = this.designFilesUploaded.concat(response.data);
          self.selectedManufactureRequest.files = self.designFilesUploaded;
          await self.updateManufactureRequestInfor();
          self.close();
        } else {
          alert('Upload error!')
        }
      }
    },

    async updateManufactureRequestInfor() {
      try {
        let imageIds = [];
        this.designFilesUploaded.forEach(item => {
          imageIds.push(item.id);
        });

        const requestBody = {
          files: imageIds
        };
        console.log(requestBody);
        const response = await this.$http.put('/manufactureRequest/' + this.selectedManufactureRequest._id + '/files', requestBody);

        if (response.data && response.data.success) {
          Object.assign(this.desserts[this.editedIndex], this.selectedManufactureRequest);
          this.overlay = false;
        }
      } catch (e) {
        console.log(e.stack);
      }
    },

    async updateManufactureRequestInforGDrive() {
      this.overlay = true;
      try {
        let requestBody = Object.assign({}, this.editedItem);
        requestBody = {
          ...requestBody,
          deadline: moment(String(this.editedItem.deadline)).format("DD/MM/YYYY"),
          receiveDate: moment(String(this.editedItem.receiveDate)).format("DD/MM/YYYY")
        }

        const response = await this.$http.put('/manufactureRequest/' + this.editedItem._id, requestBody);
        this.overlay = false;
        if (response.data && response.data.success) {
          Object.assign(this.desserts[this.editedIndex], this.editedItem);
          this.editedItem = null;
        }
      } catch (e) {
        console.log(e.stack);
        this.overlay = false;
      }
    },

    async updateManufactureRequestInforEffort(value) {
      this.overlay = true;
      this.editedItem.effort = value;
      try {
        let requestBody = Object.assign({}, this.editedItem);
        requestBody = {
          ...requestBody,
          deadline: moment(String(this.editedItem.deadline)).format("DD/MM/YYYY"),
          receiveDate: moment(String(this.editedItem.receiveDate)).format("DD/MM/YYYY")
        }

        const response = await this.$http.put('/manufactureRequest/' + this.editedItem._id, requestBody);
        this.overlay = false;
        if (response.data && response.data.success) {
          console.log(response);
          Object.assign(this.desserts[this.editedIndex], this.editedItem);
          this.editedItem = null;
        }
      } catch (e) {
        console.log(e.stack);
        this.overlay = false;
      }
    },

    async updateManufactureRequestStatus(item) {
      try {
        const requestBody = {
          designerStatus: 2
        }

        console.log('updateManufactureRequestStatus' + item);

        const response = await this.$http.put('/manufactureRequest/' + item._id + "/status", requestBody);

        if (response.data && response.data.success) {
          item.status = 1;
          Object.assign(this.desserts[this.editedIndex], this.item);

          this.$fire({
            title: i18n.t('common.update_success'),
            text: "",
            type: "success"
          }).then(() => {
            this.rateDialog = true;
            this.getData();
          });
        }
      } catch (e) {
        console.log(e.stack);
      }
    },

    async validateEffortBeforeApprove(item) {
      const self = this;
      self.editedItem = item;
      self.editedIndex = self.desserts.indexOf(item);

      this.$confirm(
          "YCTK này của bạn có thực sự mất nhiều thời gian xử lý không?",
          "",
          "question"
      ).then(async() => {
        await self.updateManufactureRequestInforEffort(1);
        await self.sendToAccountant(item);
      }).catch(async() => {
        await self.updateManufactureRequestInforEffort(0);
        await self.sendToAccountant(item);
      });
    },

    async sendToAccountant(item) {
      // const agree = confirm(i18n.t('common.confirm_create_design_request'));
      // if (!agree) {
      //   return;
      // }

      const self = this;
      this.sale = item.sale;
      if ((Array.isArray(item.files) && item.files.length > 0) || (Array.isArray(item.gDrive) && item.gDrive.length > 0)) {
        this.$confirm(
            i18n.t('common.confirm_approve'),
            "",
            "question"
        ).then(async() => {
          console.log('sendToAccountant')
          self.editedIndex = self.desserts.indexOf(item);
          await self.updateManufactureRequestStatus(item);
        }).catch(() => {

        });
      } else {
        this.$alert(
            "Chưa có file thiết kế!",
            "",
            "warning"
        ).then(() => console.log("Closed"));
      }

      // this.sale = item.sale;
      // if ((Array.isArray(item.files) && item.files.length > 0) || (Array.isArray(item.gDrive) && item.gDrive.length > 0)) {
      //   const agree = confirm(i18n.t('common.confirm_approve'))
      //   if (agree) {
      //     this.editedIndex = this.desserts.indexOf(item);
      //     await this.updateManufactureRequestStatus(item);
      //   }
      // } else {
      //   alert('Chưa có file thiết kế!');
      // }
    },

    checkTimeoutProcess(manufactureRequest) {
      var currentTime = new Date().getTime();
      var createTime = new Date(manufactureRequest.createdAt).getTime();

      if (currentTime - createTime > this.timeoutProcess * 60 * 60 * 1000) {
        return true;
      }

      return false;
    },

    async getSettingInfor() {
      // moment(String(this.deadline)).format("DD/MM/YYYY"),
      try {
        const response = await this.$http.get('/systemConfig');

        if (response.data && response.data.success) {
          const contextArr = response.data.data;
          contextArr.forEach(item => {
            if (item.key == 'ManufactureRequest_RewardTimeout') {
              this.timeoutProcess = item.value;
            }
          });
        } else if (response.data && !response.data.success) {
          alert(i18n.t(response.data.message));
        } else {
          alert(i18n.t('validate.request_error'));
        }
      } catch (e) {
        alert(i18n.t('validate.request_error'));
      }
    },

    itemRowBackground: function (item) {
      let readStatus = item.designerReadStatus === 0 ? 'unreadText' : 'readText';
      let timeoutStatus = this.checkTimeoutProcess(item) ? 'timeoutText' : '';
      return readStatus + ' ' + timeoutStatus;
    }
  },
}
</script>

<style scoped>
.linkText {
  color: #F08942
}

.small-button {
  font-size: 14px;
  font-style: normal;
  font-weight: normal;
  color: #F08942;
}

.nowrap-overflow {
  flex-wrap: nowrap;
  overflow-x: auto;
}
</style>